import React from 'react';
import Image from 'next/image';
import styles from './section.module.scss';
import SectionModel from '../../../models/section';
import GetComponent from '../../../maps/components';
import { generateBlurDataURL } from '../../../helpers/image-placeholders';

type Props = {
  data: SectionModel;
};

const Section = ({ data }: Props) => (
  <section
    className={styles.section}
    style={{ background: data?.bacground?.color }}
    id={data.id}
  >
    {data?.bacground?.media && (
      <div className={styles.section__background}>
        <Image
          placeholder="blur"
          alt={data.bacground.media.alt}
          src={data.bacground.media.src}
          layout="fill"
          objectFit="cover"
          quality={100}
          blurDataURL={generateBlurDataURL(data.bacground.media.src)}
        />
      </div>
    )}
    <div className={styles.section__components}>
      {data?.components &&
        data?.components.map((item: any, index: number) =>
          GetComponent(item, index)
        )}
    </div>
  </section>
);

export default Section;
